import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCapitalizeFirst]'
})
export class CapitalizeFirstDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    if (inputValue.length > 0) {
      const capitalizedValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
      this.renderer.setProperty(inputElement, 'value', capitalizedValue);
    }
  }
}
